module.exports = __webpack_public_path__ + "static/media/success.5f2f3b77.svg";